module.exports = __webpack_public_path__ + "static/media/back_arrow.768a9317.svg";